import { calendarEventConstants } from '@constants/calendarEvent.constants';

const initialState = {
  isFetchingCalendarEvent: false,
  formCalendarEvent: null,
  calendarEvent: null,

  isFetchingCalendarEvents: false,
  isFetchingCalendarEventsFrom: 0,
  calendarEventsTotalResults: 0,
  calendarEventsLoaded: 0,
  calendarEvents: [],
};

export default function calendarEvent(state = initialState, action) {
  switch (action.type) {
    case calendarEventConstants.CALENDAREVENT_CHANGE_VALUE:
      return { ...state, error: '', [action.name]: action.value };

    case calendarEventConstants.GET_CALENDAREVENT_STARTED:
      return { ...state, isFetchingCalendarEvent: true };
    case calendarEventConstants.GET_CALENDAREVENT_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: null,
        error: action.message || '',
      };
    case calendarEventConstants.GET_CALENDAREVENT_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: action.calendarEvent,
      };

    case calendarEventConstants.GET_CALENDAREVENTS_STARTED:
      return {
        ...state,
        isFetchingCalendarEvents: true,
        isFetchingCalendarEventsFrom: action.from || 0,
      };
    case calendarEventConstants.GET_CALENDAREVENTS_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvents: false,
        calendarEvents: [],
        error: action.message || '',
      };
    case calendarEventConstants.GET_CALENDAREVENTS_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvents: false,
        calendarEvents:
          action.from > 0
            ? [...state.calendarEvents, ...action.calendarEvents]
            : action.calendarEvents,
        calendarEventsLoaded:
          action.from > 0
            ? state.calendarEvents.length + action.calendarEvents.length
            : action.calendarEvents.length,
        calendarEventsTotalResults: action.totalResults || 0,
      };

    case calendarEventConstants.SEARCH_CALENDAREVENTS_STARTED:
      return {
        ...state,
        isFetchingCalendarEvents: true,
        isFetchingCalendarEventsFrom: action.from || 0,
      };
    case calendarEventConstants.SEARCH_CALENDAREVENTS_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvents: false,
        calendarEvents: [],
        error: action.message || '',
      };
    case calendarEventConstants.SEARCH_CALENDAREVENTS_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvents: false,
        calendarEvents:
          action.from > 0
            ? [...state.calendarEvents, ...action.calendarEvents]
            : action.calendarEvents,
        calendarEventsLoaded:
          action.from > 0
            ? state.calendarEvents.length + action.calendarEvents.length
            : action.calendarEvents.length,
        calendarEventsTotalResults: action.totalResults || 0,
      };

    case calendarEventConstants.CREATING_CALENDAREVENT_STARTED:
      return { ...state, isFetchingCalendarEvent: true };
    case calendarEventConstants.CREATING_CALENDAREVENT_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: null,
        error: action.message || '',
      };
    case calendarEventConstants.CREATING_CALENDAREVENT_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: action.calendarEvent,
        calendarEvents: [action.calendarEvent, ...state.calendarEvents],
      };

    case calendarEventConstants.UPDATING_CALENDAREVENT_STARTED:
      return { ...state, isFetchingCalendarEvent: true };
    case calendarEventConstants.UPDATING_CALENDAREVENT_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: null,
        error: action.message || '',
      };
    case calendarEventConstants.UPDATING_CALENDAREVENT_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: action.calendarEvent,
        calendarEvents: [...state.calendarEvents].map((calendarEvent) => {
          if (action.calendarEvent.id === calendarEvent.id) {
            return action.calendarEvent;
          }
          return calendarEvent;
        }),
      };

    case calendarEventConstants.DELETE_CALENDAREVENT_STARTED:
      return { ...state, isFetchingCalendarEvent: true };
    case calendarEventConstants.DELETE_CALENDAREVENT_FAILURE:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: null,
        message: action.message || '',
      };
    case calendarEventConstants.DELETE_CALENDAREVENT_SUCCESS:
      return {
        ...state,
        isFetchingCalendarEvent: false,
        calendarEvent: action.calendarEvent,
        calendarEvents: [...state.calendarEvents].filter(
          (calendarEvent) => action.calendarEvent.id !== calendarEvent.id
        ),
      };
    default:
      return state;
  }
}
